import {v4 as uuidv4} from 'uuid';
import {ContentHomeRecommendVo} from '../../common/shared/api/nicolas/vo/ContentHomeRecommendVo.interface';
import {ContentHomeRecommend, Maybe, User} from '../generated/types';
import {createContentRecommendGroup} from './ContentRecommendGroup';

export function createContentHomeRecommend(
  userInfo: Maybe<User>,
  {
    series_id,
    vo: {layout},
  }: {
    series_id: number;
    vo: ContentHomeRecommendVo;
  }
): ContentHomeRecommend {
  return {
    id: uuidv4(),
    seriesId: series_id,
    list: layout
      ? layout
          .slice(0, 10) // 기획 결정으로 최대 10개만 보여줍니다(https://podotree.atlassian.net/wiki/spaces/SVC/pages/2674786440/PC#3-3.-%ED%99%88%ED%83%AD-%E3%80%89-%EC%B6%94%EC%B2%9C%EC%BD%98%ED%85%90%EC%B8%A0)
          .map(item =>
            createContentRecommendGroup(userInfo, {contentRecommendVo: item})
          )
      : [],
  };
}
